import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    MobileStatue: 0,//0代表pc端，1代表手机端
  },
  mutations: {
    getMobileStatue(state) {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      if(flag == null){
        state.MobileStatue = 0;
      }else{
        state.MobileStatue = 1;
      }
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js